<div class="no-access-container">
    <div class="no-access-card">
        <div class="no-access-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="8" x2="12" y2="12" />
                <line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
        </div>
        <h1 class="no-access-title">Access Denied</h1>
        <p class="no-access-message">
            You do not have direct access to this application.
        </p>
    </div>
</div>
